import { useEffect } from "@wordpress/element";
import { useSelector, useDispatch } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import OrderSummary from "vino/components/WineEventBooking/steps/OrderSummary";
import Address from "vino/components/Invoice/Address";
import { resetEventBooking } from "store/vino/eventBookingSlice";

const BookingDetails = () => {
	const dispatch = useDispatch();
	const eventInformation = useSelector(({ vino }) => vino.eventBooking);

	useEffect(() => {
		return () => {
			dispatch(resetEventBooking());
		};
	}, []);

	if (!eventInformation) {
		return null;
	}

	return (
		<>
			<div className="flex flex-col w-xl">
				<Card
					component={motion.div}
					initial={{ x: 200 }}
					animate={{ x: 0 }}
					transition={{ bounceDamping: 0 }}
					className="w-full max-w-400 mx-auto m-16 md:m-0 rounded-16 md:rounded-none"
					square
					layout
				>
					<CardContent className="p-88 ">
						<Typography className="text-3xl text-center  mb-38" variant="h6">
							<span className="font-semibold">
								Your Order Placed Successfully !
							</span>
						</Typography>
						<div className="flex justify-between">
							<div className="pt-16">
								<Typography
									className="font-light"
									variant="h6"
									color="textSecondary"
								>
									Booking details
								</Typography>
							</div>
						</div>
						<div className="flex flex-shrink-0 items-center justify-between h-64">
							<Address
								title="Billing Address"
								address={eventInformation.customer?.address}
							/>
						</div>
						<OrderSummary title="Order Details" />
					</CardContent>
				</Card>
			</div>
		</>
	);
};

export default BookingDetails;
